/**
 * ارزیابیِ امنِ عبارت‌های حسابیِ ساده — موتورِ «مثلِ اکسل» فیلدهای تعداد.
 *
 * جدا از کامپوننت نگه داشته شده تا منطقِ محاسبه بدونِ React قابلِ تست باشد.
 * هیچ‌وقت از eval/Function استفاده نمی‌شود؛ ورودیِ کاربر فقط داده است، نه کد.
 */
import { toEnglishDigits } from "./digitNormalizer";

/** ارزیابیِ امنِ عبارتِ حسابی — بازگشتی، بدونِ eval. خطا ⇒ null */
export function evalExpression(raw) {
  const src = toEnglishDigits(String(raw ?? ""))
    .replace(/[×✕xX]/g, "*")
    .replace(/[÷]/g, "/")
    .replace(/[−–—]/g, "-")
    .replace(/[٫,،]/g, ".")
    .replace(/\s+/g, "");
  if (!src) return null;
  if (!/^[0-9+\-*/().]+$/.test(src)) return null;

  let i = 0;
  const peek = () => src[i];
  const eat = (c) => (src[i] === c ? (i += 1, true) : false);

  // expr := term (('+'|'-') term)*
  function expr() {
    let v = term();
    if (v === null) return null;
    for (;;) {
      if (eat("+")) {
        const r = term();
        if (r === null) return null;
        v += r;
      } else if (eat("-")) {
        const r = term();
        if (r === null) return null;
        v -= r;
      } else return v;
    }
  }
  // term := factor (('*'|'/') factor)*
  function term() {
    let v = factor();
    if (v === null) return null;
    for (;;) {
      if (eat("*")) {
        const r = factor();
        if (r === null) return null;
        v *= r;
      } else if (eat("/")) {
        const r = factor();
        if (r === null || r === 0) return null;   // تقسیم بر صفر ⇒ نامعتبر
        v /= r;
      } else return v;
    }
  }
  // factor := ('+'|'-')? ( number | '(' expr ')' )
  function factor() {
    if (eat("+")) return factor();
    if (eat("-")) {
      const v = factor();
      return v === null ? null : -v;
    }
    if (eat("(")) {
      const v = expr();
      if (v === null || !eat(")")) return null;
      return v;
    }
    const start = i;
    while (peek() && /[0-9.]/.test(peek())) i += 1;
    if (i === start) return null;
    const n = Number(src.slice(start, i));
    return Number.isFinite(n) ? n : null;
  }

  const out = expr();
  if (out === null || i !== src.length || !Number.isFinite(out)) return null;
  return out;
}

/** آیا متن یک «عبارت» است (نه فقط یک عدد)؟ — برای نمایشِ پیش‌نمایشِ نتیجه.
 *  کاراکترِ اول نادیده گرفته می‌شود تا «-۵» عبارت حساب نشود. */
export const isExpression = (t) =>
  /[+\-*/()×÷−]/.test(toEnglishDigits(String(t ?? "")).slice(1));
